import { useMutation } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import type {
  FilterGroup,
  GoalAggregationKind,
  GoalAttribution,
  GoalDataSource,
} from "@colab/shared";

export type GoalSpecInput = {
  data_source: GoalDataSource;
  aggregation_kind: GoalAggregationKind;
  aggregation_property: string | null;
  date_property: string;
  attribution: GoalAttribution;
  filter: FilterGroup;
};

export type PreviewGoalInput = {
  spec: GoalSpecInput;
  partnerId: string | null;
  period: { start: string; end: string };
};

export type GoalPreviewSample = {
  id: string;
  label: string;
  value: number | null;
  date: string | null;
};

export type GoalPreviewResult = {
  count: number;
  sum: number;
  matchedSample: GoalPreviewSample[];
};

type PreviewGoalResponse = { result: GoalPreviewResult };

// POST /api/admin/goals/preview
//
// READ action exposed as a mutation because the legacy editor calls it on
// every debounced edit with transactional editor state (not a stable
// cacheable input). Permission gate is `goals.read`, not `goals.manage` —
// non-write CRM Users can still see preview numbers during a read-only
// editor session. No invalidations; no audit row.
export function usePreviewGoal() {
  return useMutation<PreviewGoalResponse, ApiClientError, PreviewGoalInput>({
    mutationFn: (input) =>
      apiFetch<PreviewGoalResponse>("/admin/goals/preview", {
        method: "POST",
        body: JSON.stringify(input),
      }),
  });
}
